import { useContext } from 'react';

import { KeycloakContext, KeycloakRoleDefinition, KeycloakService } from './KeycloakContext';

export function UseKeycloakService() {
    const ctx = useContext(KeycloakContext);

    if (!ctx) {
        throw new Error('useKeycloak hook must be used inside ReactKeycloakService context');
    }

    if (!ctx.keycloakInstance) {
        throw new Error('authClient has not been assigned to ReactKeycloakService');
    }

    if (!ctx.keycloakService) {
        const service = new KeycloakService(ctx.keycloakInstance, ctx.initialized);
        ctx.setKeycloakService(service);
        return service;
    }

    const { keycloakService } = ctx;

    return keycloakService;
}

export function UseKeycloakCheckRole() {
    const kc = UseKeycloakService();
    return (role: KeycloakRoleDefinition) => kc.checkRole(role);
}

export default UseKeycloakService;
